(() => {
  if (window.rootlabReady) return;
  window.rootlabReady = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.rl-mobile-menu a');
    if (link) link.closest('details').removeAttribute('open');
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.rl-mobile-menu[open]').forEach(menu => {
      menu.removeAttribute('open');
      menu.querySelector('summary').focus();
    });
  });
  const observe = () => {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('rl-reveal'); observer.unobserve(entry.target); }
    }), {threshold: 0.08});
    document.querySelectorAll('.rl-application-main, .rl-why-grid article').forEach(el => observer.observe(el));
  };
  observe();
  document.addEventListener('shopify:section:load', observe);
})();

// Carry the chosen application into the native contact form.
document.addEventListener('click', event => {
 const link = event.target.closest('[data-landlab-application]');
 if (!link || link.getAttribute('href') !== '#landlab-enquiry') return;
 const select = document.querySelector('[data-landlab-select]');
 if (select && [...select.options].some(option => option.value === link.dataset.landlabApplication)) {
  select.value = link.dataset.landlabApplication;
  select.dispatchEvent(new Event('change', {bubbles:true}));
 }
});
